export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10682.1a4ba95d.jpg";